import { useCurrentUser } from "./useCurrentUser";

/**
 * Gates UI behind a stored Action (see app/actions_registry.py on the
 * backend). "Admin" role bypasses every check; everyone else needs the
 * given action key assigned to them (currentUser.allowedActions, returned
 * by GET /me).
 *
 * Usage: const canAddButton = useHasAction("smart_buttons_add_single");
 */
export const useHasAction = (actionKey: string): boolean => {
  const { data: currentUser } = useCurrentUser();

  if (!currentUser) return false;
  if (currentUser.roleName === "Admin") return true;

  return currentUser.allowedActions?.includes(actionKey) ?? false;
};

export default useHasAction;
